"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateVisitorStepDto = instanceOfUpdateVisitorStepDto;
exports.UpdateVisitorStepDtoFromJSON = UpdateVisitorStepDtoFromJSON;
exports.UpdateVisitorStepDtoFromJSONTyped = UpdateVisitorStepDtoFromJSONTyped;
exports.UpdateVisitorStepDtoToJSON = UpdateVisitorStepDtoToJSON;
exports.UpdateVisitorStepDtoToJSONTyped = UpdateVisitorStepDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateVisitorStepDto interface.
 */
function instanceOfUpdateVisitorStepDto(value) {
    if (!('currentStep' in value) || value['currentStep'] === undefined)
        return false;
    return true;
}
function UpdateVisitorStepDtoFromJSON(json) {
    return UpdateVisitorStepDtoFromJSONTyped(json, false);
}
function UpdateVisitorStepDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentStep': json['currentStep'],
    };
}
function UpdateVisitorStepDtoToJSON(json) {
    return UpdateVisitorStepDtoToJSONTyped(json, false);
}
function UpdateVisitorStepDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'currentStep': value['currentStep'],
    };
}
